import ImageWithHeadingAndText from "./imageWithHeadingAndText"

export default ImageWithHeadingAndText
